import type { CompanyCommonQuestionType } from '@optimus/models/src/services/member-profile-service/models/CompanyCommonQuestionType';
import type { ISubscription } from '@optimus/models/src/services/member-profile-service/models/ISubscription';

export interface BusinessTrade {
  id?: string;
  name: string;
  order: number;
}

export interface Member {
  id: string;
  businessMainIndustry?: string;
  companyName?: string;
  companyAddressStreet?: string;
  companyAddressCity?: string;
  companyAddressState?: string;
  companyAddressCountry?: string;
  companyAddressZipCode?: string;
  companyFullAddress?: string;
  companyEmail?: string;
  companyWebsiteUrl?: string;
  companyPhoneNumber?: string;
  phoneNumber?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  edgeEnrollmentDate?: string;
  companyRoleId?: string;
  solutionOrgMemberKey: string;
  isMasterAccount?: boolean;
  myPurchasesAccess?: boolean;
  historicRebateAccess?: boolean;
  companyRole?: {
    id: string,
    name: string,
  };
  company?: {
    id: string;
    name: string;
    businessTrades?: BusinessTrade[];
    principalEmail?: string;
    profileUpdatedAt?: string;
    partnerEnrollmentQuestions?: CompanyCommonQuestionType;
    subscription?: ISubscription | null;
  }
}

/**
 * SN's master/sub-account access grants (see SN-190) are only ever written from a
 * fresh membership-check API response - never from onboarding form answers. Exclude
 * them from the key type used by the onboarding form-answer mappers so a wrong or
 * mistyped `memberProperty` can't be assigned a value of the wrong type for any
 * `Member` field, without having to drop key/value type checking entirely.
 */
export type OnboardingFormMemberProperty = Exclude<
keyof Member, 'isMasterAccount' | 'myPurchasesAccess' | 'historicRebateAccess'
>;

export interface MemberConfig {
  id: string;
  memberId: string;
  showFollowTopicsCard: boolean;
  showBehrPromotion: boolean;
  showWelcomeModal: boolean;
  showOnboardingChecklist: boolean
}

export const MemberLoginType = {
  OTP: 'otp',
  MAGIC_LINK: 'magic_link',
};
